import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Heading from '../common/Heading';

const About = () => {
  return (
    <div className='about' id='about'>
      <Heading as="h1" heading='Notarin Yvonne Luz' subHeading='Über mich' />

      <Container>
        <Row>
          <Col xs={12} md={6} lg={8}>
            <p className='text'>
              Notare werden benötigt, wenn die notarielle Beurkundung oder Beglaubigung gesetzlich vorgeschrieben ist.
              Aber auch darüber hinaus sind Notare kompetente Ansprechpartner und Berater.
            </p>
            <p className='text'>
              Die Kanzlei geht hervor aus der Bürogemeinschaft der Notare Mark Lindenmaier und Yvonne Luz, Nachfolger
              der Sozietät der Notare Ernst Weinmann und Mark Lindenmaier sowie deren Vorgänger Notar Alfred Gläser und
              Notar Albrecht Majerle, allesamt Notare in Stuttgart Bad Cannstatt, und reicht damit bis in das Jahr 1947
              zurück. Die Bürogemeinschaft der Notare Mark Lindenmaier und Yvonne Luz ist seit dem 1. Juni 2025 beendet.
              Notar Lindenmaier ist in den Ruhestand getreten.
            </p>
            <p className='text'>
              Einzelheiten zum Serviceangebot sowie informative Broschüren zu verschiedenen Rechtsgebieten finden Sie
              unter dem Menüpunkt Tätigkeitsfelder.
            </p>
            <p className='text'>
              Vorlagen für die Vorbereitung von Immobilienkaufverträgen, von Schenkungsverträgen, zur GmbH-Gründung und
              für General- und Vorsorgevollmachten sind im Menüpunkt Formulare eingestellt.
            </p>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <div className='contact-box'>
              <hr className='contact-ruler' />
              <h3 className='contact-heading'>Kontakt</h3>
              <p className='contact-text opening-days'>Montag - Freitag</p>
              <p className='contact-text opening-hours'>08:00 Uhr - 17:00 Uhr</p>
              <p className='contact-text appointment-info'>sowie nach Vereinbarung</p>

              <p className='contact-text telephone'>
                <span>T:</span> +49 (0) 711 955 926 0
              </p>
              <p className='contact-text fax'>
                <span>F:</span> +49 (0) 711 955 926 99
              </p>
              <p className='contact-text mail'>
                <span>M:</span> info@ll-notare.de
              </p>

              <p className='contact-text street'>Kreuznacher Straße 68</p>
              <p className='contact-text city'>70372 Stuttgart Bad Cannstatt</p>
              <hr className='contact-ruler' />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;
